import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\Final Projects Repo\\LocoBuzzWebsite\\locobuzz-website\\app\\industries\\energy-utilities\\EnergyBody.jsx");
